<div class="flex max-h-[calc(100vh-3rem)] w-[520px] flex-col overflow-hidden">
  <!-- Header -->
  <div class="flex items-center gap-3 px-6 pt-5 pb-4">
    <span class="ui-badge-accent w-8 h-8 rounded-full border flex items-center justify-center shrink-0">
      <span class="material-icons text-neutral-600 dark:text-neutral-400" style="font-size: 18px">settings</span>
    </span>
    <h2 class="ui-text-primary text-base font-semibold">Paramètres</h2>
  </div>

  <!-- Body: sidebar + content -->
  <div class="flex min-h-0 flex-1">
    <!-- Left menu -->
    <nav class="flex w-40 shrink-0 flex-col gap-0.5 px-3 pb-4">
      <button
        type="button"
        class="flex items-center gap-2 rounded-md px-2.5 py-1.5 text-left transition-colors cursor-pointer"
        [class.bg-neutral-100]="activeTab() === 'theme'"
        [class.dark:bg-neutral-800]="activeTab() === 'theme'"
        [class.hover:bg-neutral-50]="activeTab() !== 'theme'"
        [class.dark:hover:bg-neutral-800/50]="activeTab() !== 'theme'"
        (click)="activeTab.set('theme')"
      >
        <span
          class="material-icons"
          style="font-size: 18px"
          [class.ui-accent-text]="activeTab() === 'theme'"
          [class.ui-text-muted]="activeTab() !== 'theme'"
          >palette</span
        >
        <span
          class="text-[13px]"
          [class.ui-text-primary]="activeTab() === 'theme'"
          [class.font-medium]="activeTab() === 'theme'"
          [class.ui-text-secondary]="activeTab() !== 'theme'"
          >Apparence</span
        >
      </button>
      <button
        type="button"
        class="flex items-center gap-2 rounded-md px-2.5 py-1.5 text-left transition-colors cursor-pointer"
        [class.bg-neutral-100]="activeTab() === 'filters'"
        [class.dark:bg-neutral-800]="activeTab() === 'filters'"
        [class.hover:bg-neutral-50]="activeTab() !== 'filters'"
        [class.dark:hover:bg-neutral-800/50]="activeTab() !== 'filters'"
        (click)="activeTab.set('filters')"
      >
        <span
          class="material-icons"
          style="font-size: 18px"
          [class.ui-accent-text]="activeTab() === 'filters'"
          [class.ui-text-muted]="activeTab() !== 'filters'"
          >filter_list</span
        >
        <span
          class="text-[13px]"
          [class.ui-text-primary]="activeTab() === 'filters'"
          [class.font-medium]="activeTab() === 'filters'"
          [class.ui-text-secondary]="activeTab() !== 'filters'"
          >Filtres</span
        >
      </button>
    </nav>

    <!-- Separator -->
    <div class="w-px bg-neutral-200 dark:bg-neutral-700 my-1"></div>

    <!-- Right content -->
    <div class="min-h-0 flex-1 overflow-y-auto px-5 pb-4">
      @if (activeTab() === 'theme') {
      <!-- Theme Color -->
      <section>
        <h4 class="ui-text-secondary text-[11px] font-semibold uppercase tracking-wide mb-2.5">Couleur du thème</h4>
        <div class="grid grid-cols-4 gap-1.5">
          @for (item of themeColors; track item.color) {
          <button
            type="button"
            class="flex flex-col items-center gap-1.5 p-2 rounded-lg border-2 transition-all cursor-pointer"
            [class.ui-row-hover]="themeColor() !== item.color"
            [style.border-color]="themeColor() === item.color ? item.hex : 'transparent'"
            (click)="selectColor(item.color)"
          >
            <span class="w-7 h-7 rounded-full flex items-center justify-center" [style.background-color]="item.hex">
              @if (themeColor() === item.color) {
              <span class="material-icons text-white" style="font-size: 16px">check</span>
              }
            </span>
            <span class="ui-text-secondary text-[11px]">{{ item.label }}</span>
          </button>
          }
        </div>
      </section>

      <!-- Color Scheme -->
      <section class="mt-5">
        <h4 class="ui-text-secondary text-[11px] font-semibold uppercase tracking-wide mb-2.5">Mode d'affichage</h4>
        <div class="grid grid-cols-3 gap-1.5">
          @for (item of schemeModes; track item.value) {
          <button
            type="button"
            class="flex flex-col items-center gap-1.5 p-2.5 rounded-lg border-2 transition-all cursor-pointer"
            [class.ui-row-hover]="colorScheme() !== item.value"
            [style.border-color]="colorScheme() === item.value ? 'var(--ui-accent-soft-text)' : 'transparent'"
            (click)="selectScheme(item.value)"
          >
            <span
              class="material-icons text-xl"
              [class.ui-accent-text]="colorScheme() === item.value"
              [class.ui-text-muted]="colorScheme() !== item.value"
              >{{ item.icon }}</span
            >
            <span
              class="text-[11px]"
              [class.ui-accent-text]="colorScheme() === item.value"
              [class.ui-text-secondary]="colorScheme() !== item.value"
              >{{ item.label }}</span
            >
          </button>
          }
        </div>
      </section>
      } @if (activeTab() === 'filters') {
      <!-- Filter Persistence -->
      <div>
        <p class="ui-text-secondary text-[11px] mb-3">
          Choisissez les pages dont les filtres doivent être conservés entre les visites.
        </p>

        <div class="flex flex-col gap-1">
          @for (page of filterPages; track page.key) {
          <button
            type="button"
            class="flex items-center justify-between rounded-md px-2.5 py-1.5 text-left transition-colors cursor-pointer"
            [class.ui-row-hover]="true"
            (click)="toggleFilterPersistence(page.key)"
          >
            <span class="ui-text-primary text-[13px]">{{ page.label }}</span>
            <span
              class="material-icons"
              style="font-size: 22px"
              [class.ui-accent-text]="isFilterPersisted(page.key)"
              [class.ui-text-muted]="!isFilterPersisted(page.key)"
              >{{ isFilterPersisted(page.key) ? 'toggle_on' : 'toggle_off' }}</span
            >
          </button>
          }
        </div>
      </div>
      }
    </div>
  </div>

  <!-- Footer -->
  <div class="px-5 py-3 flex justify-end">
    <button
      type="button"
      class="ui-button-neutral inline-flex items-center gap-1.5 rounded-full px-3.5 py-1.5 text-sm border transition"
      (click)="close()"
    >
      Fermer
    </button>
  </div>
</div>
